import { useTheme as useSCTheme } from 'styled-components';
export function useTheme() {
  return useSCTheme();
}